import { useBehavior } from '@libs/core';
import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { THorizontalLayoutOption } from '../../types/options';
import { HorizontalLayoutView } from './HorizontalLayoutView';

/**
 * Standalone horizontal layout widget driven entirely by server-provided configuration.
 * Owns behavior hooks (useBehavior) and delegates rendering to HorizontalLayoutView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
const HorizontalLayoutWidget = ({ widget, children }: React.PropsWithChildren<TWidgetProps<TCommonData, THorizontalLayoutOption>>) => {
    const { isHidden } = useBehavior(widget);

    return (
        <HorizontalLayoutView
            uid={widget.uid}
            isHide={isHidden}
            margin={widget.options?.margin}
            alignment={widget.options?.alignment}
            arrangement={widget.options?.arrangement}
            backgroundColor={widget.options?.backgroundColor}
            backgroundImage={widget.options?.backgroundImage}
            version={widget.version}
            styleName={widget.options?.style}
        >
            {children}
        </HorizontalLayoutView>
    );
};

export { HorizontalLayoutWidget };
